import React, { useState, useEffect, Component } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import moment from 'moment/moment';
import "../pagination/pagination.css"
import WindowedSelect from 'react-windowed-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ClipLoader, PropagateLoader } from 'react-spinners';
import { FaFileCircleExclamation } from "react-icons/fa6";
import LeaseApiService from "../../services/apiService";
import { RiRefreshLine } from "react-icons/ri";
import { toast } from 'react-toastify';
import Pagination from '../pagination/pagination';
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx-js-style";

const ReportTwo = ({ statusLIst, listProperty, landloardList, setreportList, reportList }) => {

    const apiService = new LeaseApiService();
    const [FilterTab, setFilterTab] = useState(true);
    const [loading, setLoading] = useState(false);
    const [unitList, setUnitList] = useState([]);
    const [pageSize, setPageSize] = useState(20);
    const [pagination, setPagination] = useState();
    const [exportData, setExportData] = useState([]);

    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    };
    const [details, setDetails] = useState({
        Proprty: [{ label: 'Select Property', value: '' }],
        unitNo: [{ label: 'Select Unit No', value: '' }],
        landloard: [{ label: 'Select landloard', value: '' }],
        status: [{ label: 'Select Status', value: '' }],
        from: "",
        to: "",
    });

    useEffect(() => {
        const today = new Date();
        let todate = formatDate(today)
        setDetails((prev) => ({ ...prev, from: todate, to: todate }));
    }, []);

    const dateFormatter = (params) => {
        const date = moment(params.value);
        return date.format("DD-MMM-YYYY");
    };
    const dateComparator = (date1, date2) => {
        const momentDate1 = moment(date1);
        const momentDate2 = moment(date2);
        return momentDate1.isSame(momentDate2) ? 0 : momentDate1.isBefore(momentDate2) ? -1 : 1;
    };
    const columnDefs = [
        { headerName: 'Customer Name', field: 'custName', filter: true, floatingFilter: true, suppressMovable: true, width: 400 },
        { headerName: 'Agent', field: 'agent', filter: true, floatingFilter: true, suppressMovable: true, width: 250 },
        {
            headerName: "Schedule Date", field: "schDate", filter: true, floatingFilter: true,
            valueFormatter: dateFormatter,
            comparator: dateComparator, suppressMovable: true, width: 136
        },
        { headerName: "From Time", field: "schFromTime", filter: true, floatingFilter: true, suppressMovable: true, width: 136 },
        { headerName: "To Time", field: "schToTime", filter: true, floatingFilter: true, suppressMovable: true, width: 136 },
        { headerName: 'Status', field: 'status', filter: true, floatingFilter: true, suppressMovable: true, width: 180 },

    ];
    const handleDropDownChange = async ({ name, value }) => {
        if (name === "Proprty" && !value) {
            // property cleared: drop the unit selection and its list
            setUnitList([]);
            setDetails(prev => ({ ...prev, Proprty: null, unitNo: null }));
            return;
        }
        if (name === "Proprty") {
            const params = new URLSearchParams();
            params.append('DropdownFor', 'PTSearchUnitNosByPropertyId');
            params.append('CascadValue', value?.value);
            const res = await apiService.getApiParamater('CASCAD_PROPRTYTOUR', `?${params.toString()}`);
            setUnitList(res?.data?.items || []);
        }
        setDetails(prev => ({ ...prev, [name]: value }));
    }
    const handleDateChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;

        const updatedValue = typeof value === 'string' ? value : formatDate(value); // Ensure "DD-MMM-YYYY"
        let updatedDates = { ...details, [name]: updatedValue };
        setDetails(updatedDates);
    }
    const handleClearFilters = () => {
        const today = new Date();
        let todate = formatDate(today)
        setDetails({
            Proprty: [{ label: 'Select Property', value: '' }],
            unitNo: [{ label: 'Select Unit No', value: '' }],
            landloard: [{ label: 'Select landloard', value: '' }],
            status: [{ label: 'Select Status', value: '' }],
            from: todate,
            to: todate,
        });

    }
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            setLoading(true)
            if (!details?.Proprty?.value) {
                toast.warning("Select Property")
                setLoading(false)
                return
            } else if (!details?.unitNo?.label) {
                toast.warning("Select Unit No")
                setLoading(false)
                return
            }
            const today = new Date();
            let todate = formatDate(today)
            const params = new URLSearchParams();
            params.append("PageNo", 1);
            params.append("PageSize", pageSize || 20);
            params.append("FromDate", details?.from || todate);
            params.append("ToDate", details?.to || todate);
            params.append("Landlord", details?.landloard?.label || "All");
            params.append("Property", details?.Proprty?.value?.value || "All");
            params.append("Unit", details?.unitNo?.label || "All");
            params.append("Status", details?.status?.label || "All");
            const res = await apiService.getApiParamater("GET_REPORT_TWO_PROPRTYTOUR", `?${params.toString()}`);
            if (res?.data?.result) {
                let result = res?.data?.result
                setPagination(res.data.paginationData);
                setreportList(result || []);
                getAllItems(res.data.paginationData)
                setLoading(false)
            } else {
                setPagination(res.data.paginationData);
                setreportList(res?.data?.result || []);
                toast.error(res?.data?.message)
                setLoading(false);
            }
        } catch (error) {
            console.error("Error fetching items:", error);
            setLoading(false); // Set loading to false even in case of error
        }
    }
    const getAllItems = async (total) => {
        try {
            const today = new Date();
            let todate = formatDate(today)
            const params = new URLSearchParams();
            params.append("PageNo", 1);
            params.append("PageSize", total?.totalRecords || pageSize || 20);
            params.append("FromDate", details?.from || todate);
            params.append("ToDate", details?.to || todate);
            params.append("Landlord", details?.landloard?.label || "All");
            params.append("Property", details?.Proprty?.value?.value || "All");
            params.append("Unit", details?.unitNo?.label || "All");
            params.append("Status", details?.status?.label || "All");
            const res = await apiService.getApiParamater("GET_REPORT_TWO_PROPRTYTOUR", `?${params.toString()}`);
            if (res?.data?.result) {
                setExportData(res?.data?.result || []);
            }
        } catch (error) {
            console.error("Error fetching items:", error);
        }
    }
    const getItem = async (newPageNo = pagination?.currentPage) => {
        try {
            setLoading(true)
            const today = new Date();
            let todate = formatDate(today)
            const params = new URLSearchParams();
            params.append("PageNo", newPageNo);
            params.append("PageSize", pageSize || 20);
            params.append("FromDate", details?.from || todate);
            params.append("ToDate", details?.to || todate);
            params.append("Landlord", details?.landloard?.label || "All");
            params.append("Property", details?.Proprty?.value?.value || "All");
            params.append("Unit", details?.unitNo?.label || "All");
            params.append("Status", details?.status?.label || "All");
            const res = await apiService.getApiParamater("GET_REPORT_TWO_PROPRTYTOUR", `?${params.toString()}`);
            if (res?.data?.result) {
                let result = res?.data?.result
                setPagination(res.data.paginationData);
                setreportList(result || []);
                setLoading(false)
            } else {
                setreportList(res?.data?.result || []);
                setPagination(res.data.paginationData);
                toast.error(res?.data?.message)
                setLoading(false);
            }
        } catch (error) {
            console.error("Error fetching items:", error);
            setLoading(false); // Set loading to false even in case of error
        }
    }
    const normalizeValue = (value) => {
        if (value === null || value === undefined) return "";
        if (value === 0 || value === "0") return "";

        if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(value)) {
            return moment(value).format("DD-MMM-YYYY");
        }

        return value;
    };
    const exportColumns = [
        { header: "Customer Name", dataKey: "custName" },
        { header: "Agent", dataKey: "agent" },
        { header: "Schedule Date", dataKey: "schDate" },
        { header: "From Time", dataKey: "schFromTime" },
        { header: "To Time", dataKey: "schToTime" },
        { header: "Status", dataKey: "status" },
    ];
    const exportPDF = () => {
        if (!exportData?.length) {
            toast.warning("No data to export");
            return;
        }

        const doc = new jsPDF("landscape", "pt", "A4");

        doc.setFillColor(110, 81, 153); // #6E5199
        doc.rect(0, 0, doc.internal.pageSize.width, 50, "F");

        doc.setTextColor(255);
        doc.setFontSize(16);
        doc.text("Property Tour Individual Report", 40, 32);

        doc.setFontSize(9);
        doc.text(
            `Period: ${moment(details?.from).format("DD-MMM-YYYY")} to ${moment(details?.to).format("DD-MMM-YYYY")}`,
            doc.internal.pageSize.width - 220,
            32
        );

        doc.setTextColor(0);

        doc.autoTable({
            startY: 60,
            margin: { left: 20, right: 20 },
            head: [exportColumns.map(col => col.header)],
            body: exportData.map(row =>
                exportColumns.map(col => normalizeValue(row[col.dataKey]))
            ),
            styles: {
                fontSize: 7,
                cellPadding: 4,
                valign: "middle",
                overflow: "linebreak",
            },
            headStyles: {
                fillColor: [110, 81, 153],
                textColor: 255,
                fontStyle: "bold",
                halign: "center",
            },
            bodyStyles: {
                halign: "center",
            },
            alternateRowStyles: {
                fillColor: [240, 237, 245],
            },
            didDrawPage: data => {
                doc.setFontSize(8);
                doc.text(
                    `Page ${data.pageNumber}`,
                    doc.internal.pageSize.width / 2,
                    doc.internal.pageSize.height - 10,
                    { align: "center" }
                );
            },
        });
        doc.save(`Property_Tour_Individual_Report_${moment().format("DD-MMM-YYYY_HH-mm-ss")}.pdf`);
    };
    const exportExcel = () => {
        if (!exportData?.length) {
            toast.warning("No data to export");
            return;
        }

        const dataRows = exportData.map(item =>
            exportColumns.map(col => normalizeValue(item[col.dataKey]))
        );

        const title = `PROPERTY TOUR INDIVIDUAL REPORT (Period: ${moment(details?.from).format("DD-MMM-YYYY")} to ${moment(details?.to).format("DD-MMM-YYYY")})`;

        const worksheet = XLSX.utils.aoa_to_sheet([
            [title],
            exportColumns.map(col => col.header),
            ...dataRows,
        ]);

        worksheet["!merges"] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: exportColumns.length - 1 } },
        ];

        worksheet["!cols"] = exportColumns.map((col, i) => {
            const maxLength = Math.max(
                col.header.length,
                ...dataRows.map(r => String(r[i] ?? "").length)
            );
            return { wch: Math.min(Math.max(maxLength + 3, 12), 40) };
        });

        const titleCell = worksheet["A1"];
        if (titleCell) {
            titleCell.s = {
                font: { bold: true, sz: 16, color: { rgb: "FFFFFFFF" } },
                fill: { fgColor: { rgb: "FF6E5199" } },
                alignment: { horizontal: "left", vertical: "center" },
            };
        }

        exportColumns.forEach((col, i) => {
            const colRef = XLSX.utils.encode_col(i);
            const headerCell = worksheet[`${colRef}2`];
            if (headerCell) headerCell.s = {
                font: { bold: true, color: { rgb: "FFFFFFFF" } },
                fill: { fgColor: { rgb: "FF6E5199" } },
            };
        });

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Property Tour Individual Report");
        XLSX.writeFile(workbook, `Property_Tour_Individual_Report_${moment().format("DD-MMM-YYYY_HH-mm-ss")}.xlsx`);
    };
    return (
        <div className="mt-3">
            <div className="cost-center-section">
                <div
                    className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setFilterTab(!FilterTab)}
                >
                    <div className="h6 pt-1">Schedule Details</div>
                </div>
                <div className={`slide-content ${FilterTab ? "open" : "closed"}`}>
                    <div className={`border-box2 p-3 ${FilterTab ? "slide-in" : "slide-out"}`}>
                        <div className="form-group grid-contain ">

                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Property</label>
                                <WindowedSelect
                                    isClearable
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={details?.Proprty}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'Proprty', value: selectedOption })}
                                    options={listProperty?.map(country => ({ value: country?.value, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Unit</label>
                                <WindowedSelect
                                    isClearable
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={details?.unitNo}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'unitNo', value: selectedOption })}
                                    options={unitList?.slice()?.sort((a, b) => a.text.localeCompare(b.text, undefined, { numeric: true, sensitivity: 'base' }))?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Status</label>
                                <WindowedSelect
                                    isClearable
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={details?.status}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'status', value: selectedOption })}
                                    options={statusLIst?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Landloard</label>
                                <WindowedSelect
                                    isClearable
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={details?.landloard}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'landloard', value: selectedOption })}
                                    options={landloardList?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>

                            <div className="d-flex">
                                <label className="form-label">From</label>
                                <DatePicker
                                    selected={details.from}
                                    onChange={(date) => handleDateChange({ name: 'from', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100"
                                />
                            </div>
                            <div className="d-flex">
                                <label className="form-label">To</label>
                                <DatePicker
                                    selected={details.to}
                                    onChange={(date) => handleDateChange({ name: 'to', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100"
                                />
                            </div>
                            <div></div>
                            <div className="d-flex gap-1">
                                {loading === true ?
                                    <div className='mainbtn flex-end gap-2 w-50'>
                                        <ClipLoader color="#ffffff" className='mt-1' size={25} />
                                    </div>
                                    :
                                    <div className='mainbtn flex-end gap-2 w-50' onClick={getItems}>
                                        <FaFileCircleExclamation color="#fff" className="center mt-2 mx-2" />
                                        <div className='center'>Search</div>
                                    </div>
                                }
                                <div onClick={() => handleClearFilters()} className="mainbtnRed flex-end gap-2 w-50">
                                    <RiRefreshLine color="#fff" className="center mt-2 mx-2" />
                                    <div className="center">Reset</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='border-box2 p-3'>
                <div className='d-flex justify-content-between '>
                    <h5 className='col mainInvHead'>Property Tour Report</h5>
                    <button className="btn btn-primary" onClick={exportPDF}>
                        Export as PDF
                    </button>
                    <button className="btn btn-secondary mx-3" onClick={exportExcel}>
                        Export as Excel
                    </button>
                </div>
                <div className='gridshad  mt-2'>
                    <div className="ag-theme-quartz" style={{ height: 650 }}>
                        <AgGridReact
                            getRowStyle={(params) => {
                                if (params.node.rowIndex % 2 === 0) {
                                    return { background: '#F0EDF5' };
                                } else {
                                    return { background: '#fff' };
                                }
                            }}
                            rowData={reportList}
                            enableFilter={true}
                            floatingFilter={true}
                            columnDefs={columnDefs}
                        />
                        <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pagination} getItems={getItem} />

                    </div>
                </div>
            </div>
        </div>

    );
};
export default ReportTwo;
